import { apiCall } from '../helpers/apiHelpers';
import { ApiResult } from '../types/api/common';
import { CheckNewMessagesResponse, MessagesResponse, MessageResponse } from '../types/api/responses';

export const checkNewMessages = (sessionId: string): Promise<ApiResult<CheckNewMessagesResponse>> =>
  apiCall<CheckNewMessagesResponse>({
    method: 'GET',
    url: `/client/checknewmail?clientSessionId=${sessionId}`,
  })();

export const getAllMessages = (sessionId: string): Promise<ApiResult<MessagesResponse>> =>
  apiCall<MessagesResponse>({
    method: 'GET',
    url: `/client/mail?clientSessionId=${sessionId}`,
  })();

export const getMessageById = (sessionId: string, mailId: string): Promise<ApiResult<MessageResponse>> =>
  apiCall<MessageResponse>({
    method: 'GET',
    url: `/client/mail/${mailId}?clientSessionId=${sessionId}`,
  })();

export const getMailAttachment = (sessionId: string, mailId: string, attachmentName: string): Promise<ApiResult<any>> =>
  apiCall({
    method: 'GET',
    url: `/client/mail/${encodeURIComponent(mailId)}/attachment/${encodeURIComponent(attachmentName)}?clientSessionId=${encodeURIComponent(sessionId)}`,
    urlEncoded: true,
  })();

export const deleteMail = (sessionId: string, mailId: string): Promise<ApiResult<void>> =>
  apiCall({
    method: 'DELETE',
    url: `/client/mail/${mailId}?clientSessionId=${sessionId}`,
  })();
